import { useStaticQuery, graphql } from 'gatsby';

type TContact = {
  phone: string;
  email: string;
};

type TContactDetailsQuery = {
  allVariablesYaml: {
    nodes: Array<TContact>;
  };
};

const useContactDetails = () => {
  const { allVariablesYaml } = useStaticQuery<TContactDetailsQuery>(
    graphql`
      query ContactDetails {
        allVariablesYaml(filter: { type: { eq: "Contact" } }) {
          nodes {
            phone
            email
          }
        }
      }
    `,
  );

  const [nodes] = allVariablesYaml.nodes;

  return {
    ...nodes,
  };
};

export { useContactDetails };
